import Logo from '../../assets/logo.svg';
import Exit from '../../assets/exit.svg';
import Back from '../../assets/back.svg';
import { Link, useLocation } from 'react-router-dom';
import { useContext } from "react";
import { useUserContext } from "../../context/user";
import { useSignOut } from "../../hooks/useSignOut";

export default function AdminHeader() {
    const location = useLocation();
    const { setJwtToken, setRole, setUserUuid, setShowMy, setLayout } = useUserContext();
    const signOut = useSignOut();

    const changeLayout = () => {
        window.location.replace('/layout')
    }


    return (
        <div className="grid grid-flow-col place-content-stretch">
            <Link
                reloadDocument={true}
                to='/daily/'>
                <img className='mr-2' src={Logo} alt='logo' />
            </Link>

            <div className='grid grid-flow-col gap-1 bg-white p-1 rounded-lg h-12 my-auto'>
                <Link
                    reloadDocument={true}
                    to='/daily'
                    className={'rounded-lg text-center py-2 ' + (location.pathname.endsWith('/daily') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Суточные
                </Link>
                <Link
                    reloadDocument={true}
                    to='/cities'
                    className={'rounded-lg text-center py-2 ' + (location.pathname.startsWith('/cities') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Города
                </Link>
                <Link
                    reloadDocument={true}
                    to='/countries'
                    className={'rounded-lg text-center py-2 ' + (location.pathname.startsWith('/countries') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Страны
                </Link>
                <Link
                    reloadDocument={true}
                    to='/shops'
                    className={'rounded-lg text-center py-2 ' + (location.pathname.startsWith('/shops') ? 'bg-melon-yellow' : 'bg-white')}
                >
                    Магазины
                </Link>
            </div>
            <div className='grid grid-flow-col place-content-center justify-end gap-[10px]'>
                {/* NOTE: Disable layout  */}
                {/* <button
                    onClick={changeLayout}
                    className="bg-white rounded-lg flex flex-row justify-center items-center border w-12 h-12"
                >
                    <img src={Back} alt="" />
                </button> */}
                <button
                    onClick={signOut}
                    className="bg-white rounded-lg flex flex-row justify-center items-center border w-12 h-12"
                >
                    <img src={Exit} alt="" />
                </button>
            </div>
        </div>
    );
}